import EmployeeInfo from '@/components/CustomComponent/EmployeeInfo/EmployeeInfo';
import FollowButton from '@/components/communication/EmployeeLocations/FollowButton';
import FollowAllButton from '@/components/communication/EmployeeLocations/FollowAllButton';
import { COMMON_TEXT } from '@/helpers/common-text';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  QUERY_STRING_STORE,
  CHAT_TOOL_PRESENCE_COLOR,
} from '@/helpers/constants';
import './EmployeeLocationListRight.less';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class EmployeeLocationListRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      branch:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0],
      isLoading: false,

      sidebarVisible: false,
      selectedEmployeeInfo: null,
    };
    this.copyToast = React.createRef();
  }

  showToast = (options) => {
    if (this.copyToast.current) {
      this.copyToast.current.show(options);
    }
  };

  getAvatarColor = (employeeId) => {
    const colors = ['#5A99E6', '#FFE136', '#8F69D5', '#6CC2BD', '#FFA14F'];
    return colors[employeeId % colors.length];
  };

  renderEmployeeGroup = ({ employeeList }) => {
    if (!employeeList || employeeList.length === 0) {
      const { selectKeyTeam } = this.props;
      if (selectKeyTeam === 'FOLLOWED_EMPLOYEES') {
        return <div className="no-data-container">{COMMON_TEXT.NO_USER_FOUND}</div>;
      }
      return <div className="no-data-container">{COMMON_TEXT.NO_DATA}</div>;
    }

    employeeList = employeeList.sort((a, b) => {
      const aName = a['employee_name'] ?? '';
      const bName = b['employee_name'] ?? '';
      return aName.localeCompare(bName, 'ja');
    });

    // group employeeList by employee_name and employee_image to show only one employee
    const employeeIdentifierMap = {};
    employeeList.forEach(employee => {
      const { employee_id } = employee;
      if (!employeeIdentifierMap[employee_id]) {
        employeeIdentifierMap[employee_id] = [employee];
      } else {
        employeeIdentifierMap[employee_id].push(employee);
      }
    });

    const employeeNameOnClicked = employee => {
      const empl = {
        ...employee,
        device_type: employee?.location_info[0]?.device_type ?? 'pc',
      };
      this.setState({ sidebarVisible: true, selectedEmployeeInfo: empl });
    };

    const { followedEmployeeIds, onFollowChange } = this.props;

    return (
      <div className="employee-container-v3" style={{ width: '100%' }}>
        <FollowAllButton
          employeeList={employeeList}
          followedEmployeeIds={followedEmployeeIds || new Set()}
          onFollowChange={onFollowChange}
          showToast={this.showToast}
        />
        {employeeList &&
          employeeList.length > 0 &&
          employeeList.map((employee, index) => {
            const {
              employee_id,
              is_present: employeePresence,
              employee_name,
              employee_image_url,
              chat_tool_presence,
              chat_tool_presence_color,
            } = employee;

            const avatarColor = this.getAvatarColor(employee_id || index);
            const isFollowing = followedEmployeeIds && followedEmployeeIds.has(parseInt(employee_id));

            return (
              <div
                className="employee-item-v3"
                key={`employee-info-index-${index}-${employee_id}`}
              >
                <div className="employee-avatar-v3">
                  {employee_image_url && employee_image_url !== 'assets/images/default_employee_avatar.jpg' ? (
                    <img
                      src={employee_image_url}
                      alt={employee_name || 'Employee'}
                      onError={(e) => {
                        // Fallback to icon if image fails to load
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  <div
                    className="employee-avatar-fallback"
                    style={{
                      backgroundColor: avatarColor,
                      display: employee_image_url && employee_image_url !== 'assets/images/default_employee_avatar.jpg' ? 'none' : 'flex'
                    }}
                  >
                    <i className="pi pi-user" />
                  </div>
                </div>

                <div
                  className="employee-name-v3"
                  onClick={() => employeeNameOnClicked(employee)}
                >
                  {employee_name}
                </div>

                <FollowButton
                  employeeId={employee_id}
                  isFollowing={isFollowing}
                  onFollowChange={onFollowChange}
                  showToast={this.showToast}
                />

                <div className="employee-status-v3">
                  <div className={`presence-badge-v3 ${employeePresence ? 'present' : 'absent'}`}>
                    {employeePresence ? '在室' : '不在'}
                  </div>

                  {chat_tool_presence != null && (
                    <div className="connectivity-indicator-v3">
                      <div
                        className="connectivity-dot-v3"
                        style={{
                          backgroundColor: CHAT_TOOL_PRESENCE_COLOR[chat_tool_presence_color?.toUpperCase()] || '#808080',
                        }}
                      />
                      <span className="connectivity-text-v3">
                        {chat_tool_presence}
                      </span>
                    </div>
                  )}
                </div>

                <div className="arrow-icon-v3" onClick={() => employeeNameOnClicked(employee)}>
                  <i className="pi pi-chevron-right" />
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  componentDidMount() {
    const { branch, tenant } = this.state;
    const { isLoading } = this.props;

    this.setState({
      branch,
      tenant,
      isLoading,
    });

    // Add event listener for close sidebar
    document.addEventListener('closeSidebar', this.handleCloseSidebar);
  }

  componentWillUnmount() {
    // Remove event listener
    document.removeEventListener('closeSidebar', this.handleCloseSidebar);
  }

  handleCloseSidebar = () => {
    this.setState({ sidebarVisible: false, selectedEmployeeInfo: null });
  };

  componentDidUpdate(prevProps) {
    const { querystring, isLoading } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const branch = querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevBranch =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    const isBranchChanged = branch !== prevBranch;
    if (isTenantChanged || isBranchChanged) {
      this.setState({
        branch,
        tenant,
        isLoading,
      });
    }
  }

  render() {
    const { sidebarVisible, selectedEmployeeInfo } = this.state;
    const { empLocGroupedByTeam, employeeSearchText, selectKeyTeam, hideSearchInputs, followedEmployeeIds, onFollowChange } =
      this.props;

    return (
      <div className="right-container">
        <Toast ref={this.copyToast} position="bottom-right" />
        <Sidebar
          visible={sidebarVisible}
          onHide={() =>
            this.setState({ sidebarVisible: false, selectedEmployeeInfo: null })
          }
          closeIcon="pi pi-chevron-left"
          position="right"
          closeOnEscape={true}
          dismissable={true}
          className="employee-info-sidebar"
          showCloseIcon={false}
        >
          <EmployeeInfo
            employeeId={selectedEmployeeInfo?.['employee_id']}
            deviceType={selectedEmployeeInfo?.['device_type']}
            followedEmployeeIds={followedEmployeeIds || new Set()}
            onFollowChange={onFollowChange}
          ></EmployeeInfo>
        </Sidebar>

        {/* Only show header and search inputs if not in unified mode */}
        {!hideSearchInputs && (
          <>
            <div className="list-header">
              <h2 className="list-title">リスト</h2>
              <Button
                icon="pi pi-refresh"
                className="refresh-button"
                text
                onClick={() => this.props.onRefresh && this.props.onRefresh()}
                tooltip="更新"
              />
            </div>

            <div className="search-container">
              <div className="search-row">
                <div className="input-container">
                  <i className="pi pi-search search-icon"></i>
                  <InputText
                    className="department-search"
                    placeholder="部署"
                    value={this.props.departmentSearchText || ''}
                    onChange={e =>
                      this.props.updateSearchTextChange({
                        value: e.target.value,
                        type: 'department',
                      })
                    }
                  />
                  {this.props.departmentSearchText && (
                    <i
                      className="pi pi-times icon-clear"
                      onClick={() =>
                        this.props.updateSearchTextChange({
                          value: '',
                          type: 'department',
                        })
                      }
                    />
                  )}
                </div>

                <div className="input-container">
                  <i className="pi pi-search search-icon"></i>
                  <InputText
                    className="room-search"
                    placeholder="部屋"
                    value={this.props.roomSearchText || ''}
                    onChange={e =>
                      this.props.updateSearchTextChange({
                        value: e.target.value,
                        type: 'room',
                      })
                    }
                  />
                  {this.props.roomSearchText && (
                    <i
                      className="pi pi-times icon-clear"
                      onClick={() =>
                        this.props.updateSearchTextChange({
                          value: '',
                          type: 'room',
                        })
                      }
                    />
                  )}
                </div>

                <div className="input-container">
                  <i className="pi pi-search search-icon"></i>
                  <InputText
                    className="employee-search"
                    placeholder="検索"
                    value={employeeSearchText}
                    onChange={e =>
                      this.props.updateSearchTextChange({
                        value: e.target.value,
                        type: 'employee',
                      })
                    }
                  />
                  {employeeSearchText && (
                    <i
                      className="pi pi-times icon-clear"
                      onClick={() =>
                        this.props.updateSearchTextChange({
                          value: '',
                          type: 'employee',
                        })
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {selectKeyTeam.length === 0 &&
          employeeSearchText.length === 0 &&
          empLocGroupedByTeam.length === 0 ? (
          <div className="no-data-container">
            {COMMON_TEXT.EMPLOYEE_LOCATION_SELECT}
          </div>
        ) : (
          this.renderEmployeeGroup({
            employeeList: empLocGroupedByTeam,
          })
        )}
      </div>
    );
  }
}

EmployeeLocationListRight.propTypes = {
  isLoading: PropTypes.bool,
  employeeSearchText: PropTypes.string,
  departmentSearchText: PropTypes.string,
  roomSearchText: PropTypes.string,
  empLocGroupedByTeam: PropTypes.array,
  selectKeyTeam: PropTypes.string,
  hideSearchInputs: PropTypes.bool,
  followedEmployeeIds: PropTypes.instanceOf(Set),
  onFollowChange: PropTypes.func,

  updateSearchTextChange: PropTypes.func,
  onRefresh: PropTypes.func,
};

export default EmployeeLocationListRight;
